import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import CustomButton from "../../components/customButton";
import CommandeEncours from "../../components/commandeEncours";
import RecapCommande from "../../components/commandeInProgress";
import { scrollToTop } from "../../lib/utils";

const MesRequette = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [underlineWidth, setUnderlineWidth] = useState(0);
  const [underlineOffset, setUnderlineOffset] = useState(0);

  const navRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleNavClick = (index: number) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    const currentNavRef = navRefs.current[activeIndex];
    if (currentNavRef) {
      setUnderlineWidth(currentNavRef.offsetWidth);
      setUnderlineOffset(currentNavRef.offsetLeft);
    }
  }, [activeIndex]);

  const tabNav = [
    { label: t('mesRequettes.enCours', { count: 2 }), id: 0 },
    { label: '', id: 1 },
    { label: '', id: 2 },
    { label: '', id: 3 }
  ];

  return (
    <div className="w-full">
      <div
        className="w-full min-h-[30px] h-[239px] relative"
        style={{ backgroundImage: `url('/bio.svg')` }}
      >
        <div className="bg-black opacity-60 absolute top-0 bottom-0 left-0 right-0 z-10"></div>
        <div className="relative z-20 flex flex-col items-center justify-between pt-5 pb-8 h-full px-4">
          <h2 className="text-white text-[27px] font-normal w-full text-start">
            {t('mesRequettes.titre')}
          </h2>
          <div className="w-full flex justify-center">
            <div className="flex gap-[0.8px]">
              <div
                style={{ boxShadow: "0px 4px 4px 0px hsla(0, 0%, 0%, 0.25)" }}
                className="min-w-[200px] sm:min-w-[357px] border-[2px] h-[37px] rounded-l-[29px] border-solid border-grey relative"
              >
                <div className="absolute left-2 top-0 bottom-0 flex items-center">
                  <img src="/greySearch.svg" alt="" />
                </div>
                <input
                  className="placeholder:text-grey rounded-l-[29px] pl-8 text-xs font-normal h-full w-full min-w-[90px] border-none focus:outline-none focus:ring-0 focus:border-transparent"
                  placeholder={t('mesRequettes.rechercherPlaceholder')}
                />
              </div>
              <CustomButton
                startIcon="/search-icon.svg"
                className="h-[38px] bg-secondary rounded-r-[29px] max-w-[120px] px-3 py-2"
              >
                <span className="text-xs font-normal text-white">
                  {t('mesRequettes.rechercherBouton')}
                </span>
              </CustomButton>
            </div>
          </div>

          {/* Navigation */}
          <div className="w-full flex flex-col mt-4 relative justify-center">
            <div>
              <div className="flex gap-8 mb-2">
                {tabNav.map((item, index) => (
                  <div
                    key={index}
                    ref={(el) => (navRefs.current[item.id] = el)}
                    className="cursor-pointer text-white"
                    onClick={() => handleNavClick(item.id)}
                  >
                    <span className="text-[16px] font-normal">
                      {item.label}
                    </span>
                  </div>
                ))}
              </div>
              <div
                className="absolute bottom-0 h-[4px] bg-secondary transition-all duration-300"
                style={{
                  width: `${underlineWidth}px`,
                  transform: `translateX(${underlineOffset}px)`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className=" px-5 py-5 flex flex-col gap-3 ">
        <h2 className="font-normal text-[13px] my-4">
          {t('mesRequettes.commandesTitre', { count: 1 })}
        </h2>
        {
          activeIndex === 0 ?
            <CommandeEncours />
            : <RecapCommande />
        }
      </div>
    </div>
  );
};

export default MesRequette;